import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Confirm, DELETE, showNotification } from 'react-admin';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import dataProvider from '~config/providers/dataProvider';

const deleteStyle = { color: '#b71c1c' };

// Removes the project's Seguimiento after confirmation; the project keeps its etapa.
class DeleteTrackingButton extends Component {
  state = { open: false, deleting: false };

  handleOpen = () => this.setState({ open: true });

  handleClose = () => this.setState({ open: false });

  handleConfirm = () => {
    const { record } = this.props;
    this.setState({ deleting: true });
    dataProvider(DELETE, 'project-tracking', { id: record.id })
      .then(() => {
        this.props.showNotification('Seguimiento eliminado');
        this.props.history.push(`/projects/${encodeURIComponent(record.id)}/show`);
      })
      .catch(error => {
        this.setState({ open: false, deleting: false });
        this.props.showNotification(error.message || 'No se pudo eliminar el seguimiento', 'warning');
      });
  };

  render() {
    const { record } = this.props;
    if (!record || !record.hasTracking) return null;
    return (
      <>
        <Button style={deleteStyle} onClick={this.handleOpen} disabled={this.state.deleting}>
          <DeleteIcon style={{ marginRight: 8 }} />
          Eliminar seguimiento
        </Button>
        <Confirm
          isOpen={this.state.open}
          title="Eliminar seguimiento"
          content="Se eliminará el seguimiento del proyecto y dejará de mostrarse en la ficha pública. El proyecto conserva su etapa actual. ¿Desea continuar?"
          confirm="Eliminar"
          cancel="Cancelar"
          onConfirm={this.handleConfirm}
          onClose={this.handleClose}
        />
      </>
    );
  }
}

export default withRouter(connect(null, { showNotification })(DeleteTrackingButton));
